import React, { useEffect, useState } from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, IconButton } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";

export default function GroupEditDialog({ open, onClose, groupId, getGroup, onSave }) {
    const [form, setForm] = useState({
        windcontract_group_id: "",
        windcontract_group_name: "",
        note: "",
    });

    useEffect(() => {
        if (open && groupId) {
            (async () => {
                try {
                    const res = await getGroup(groupId);
                    // res maybe shape { data: {...}, message, status } or {...}
                    const data = res?.data || res;
                    const group = data?.data || data; // tolerant
                    const g = group?.id ? group : (Array.isArray(group) && group[0]) || group;
                    setForm({
                        windcontract_group_id: g?.id || groupId,
                        windcontract_group_name: g?.group_name || g?.windcontract_group_name || "",
                        note: g?.note || "",
                    });
                } catch (e) {
                    console.error("fetch group failed", e);
                }
            })();
        }
    }, [open, groupId, getGroup]);

    const handleSave = () => {
        if (!form.windcontract_group_name) {
            alert("請輸入群組名稱");
            return;
        }
        onSave({
            windcontract_group_id: form.windcontract_group_id,
            windcontract_group_name: form.windcontract_group_name,
            note: form.note,
        });
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle>
                編輯群組
                <IconButton aria-label="close" onClick={onClose} style={{ position: "absolute", right: 8, top: 8 }}>
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent dividers>
                <TextField
                    label="群組名稱"
                    fullWidth
                    margin="normal"
                    variant="outlined"
                    value={form.windcontract_group_name}
                    onChange={(e) => setForm({ ...form, windcontract_group_name: e.target.value })}
                />
                <TextField
                    label="備註"
                    fullWidth
                    margin="normal"
                    variant="outlined"
                    multiline
                    minRows={3}
                    value={form.note}
                    onChange={(e) => setForm({ ...form, note: e.target.value })}
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={handleSave} variant="contained" style={{ backgroundColor: "#5597b4", color: "#fff" }}>儲存</Button>
                <Button onClick={onClose}>取消</Button>
            </DialogActions>
        </Dialog>
    );
}
